import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { selectStoreId } from '../../features/app/selectors'
import { selectUserRole } from '../../features/auth/selectors'
import searchActions from '../../features/search/actions'
import { selectSearchTerm } from '../../features/search/selectors'
import { getUserDashboard } from '../../libs/auth'
import { useTeloDispatch, useTeloSelector } from '../../store'
import Button from '../../styleguide/buttons/Button'
import HomeIcon from '../../styleguide/icons/HomeIcon'
import LinkNoStyle from '../../styleguide/LinkNoSyle'

const HomeButton = styled(LinkNoStyle)`
	grid-column: 1;
	place-self: center left;
	.MuiButtonBase-root {
		padding: 0;
	}
`

export const LeftHomeButton = () => {
	const userRole = useTeloSelector(selectUserRole)
	const storeId = useTeloSelector(selectStoreId)
	const searchTerm = useTeloSelector(selectSearchTerm)
	const dispatch = useTeloDispatch()
	const { t } = useTranslation()

	const homeButtonDestination = getUserDashboard(userRole, storeId)
	const clearSearchTerm = () => {
		searchTerm && dispatch(searchActions.clearSearch())
	}

	return (
		<HomeButton to={homeButtonDestination} onClick={() => clearSearchTerm()}>
			<Button variant="text" startIcon={<HomeIcon />} underlined={true}>
				{t('app.home')}
			</Button>
		</HomeButton>
	)
}
